/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShiftManagerGroup = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'string',
      isRequired: true,
    },
    parentGroupId: {
      type: 'string',
    },
  },
} as const;
